import React, { Component } from "react";
import styled from "styled-components";
import Hls from 'hls.js';

import "../sass/components/video-player.scss";
import "../sass/vendors/video-js.css";
import Button from "../components/Button";
import Dropdown from "./Dropdown";
import { ReactComponent as BigPlayIcon } from "../img/icons/video-player/bigPause.svg";
import { ReactComponent as BigPauseIcon } from "../img/icons/video-player/bigPlay.svg";
// import 'videojs-contrib-ads';
// import 'videojs-ima';

// import   {registerIVSTech} from 'amazon-ivs-player';
// Import Icons
import muteIcon from "../img/icons/video-player/mute.svg";
import playButtonIcon from "../img/icons/video-player/play.svg";
import pauseButtonIcon from "../img/icons/video-player/pause.svg";
import volume_mid from "../img/icons/video-player/volume-mid.svg";
import settingsIcon from "../img/icons/video-player/settings.svg";
import volumeMax from "../img/icons/video-player/volume-max.svg";
import fullscreenIcon from "../img/icons/video-player/full-screen.svg";
import previous from "../img/icons/vector-previouswhite.svg";

// Local sequence to generate stable unique DOM ids when caller didn't pass one.
let __videoPlayerSeq = 0;

const LiveIcon = styled.div`
  user-select: none;
  pointer-events: none;
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  top: 24px;
  left: 35px;
  width: 46px;
  height: 18px;
  background: #ee4c50;
  color: white;
  font-family: "Poppins Semibold";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  text-transform: uppercase;
  text-align: center;
  border-radius: 4px;
  letter-spacing: 0.16em;
  @media only screen and (max-width: 1300px) {
    top: 15px;
    left: 17px;
    width: 30px;
    height: 15px;
    font-size: 7px;
  }
`;
const BigPlayPause = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 85px;
  height: 85px;

  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-box-shadow: 0px 0px 11px 5px rgba(0, 0, 0, 0.43);
  box-shadow: -3px -5px 24px 20px rgba(0, 0, 0, 0.31);
  -webkit-box-shadow: -3px -5px 24px 20px rgba(0, 0, 0, 0.31);
  -moz-box-shadow: -3px -5px 24px 20px rgba(0, 0, 0, 0.31);
  transition: all 800ms;
  opacity: 0;
  img {
    width: 35px;
    height: 35px;
    max-width: 35px;
    max-height: 35px;
    min-width: 35px;
    min-height: 35px;
    padding: 20px;
  }
`;
const ControlBar = styled.div`
  position: absolute;
  bottom: -1px;
  background-color: transparent;
  display: flex;
  width: 100%;
  height: 70px;
  /* justify-content: space-between; */
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  background-image: linear-gradient(
    -180deg,
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.6)
  );
  transition: all 500ms;
  @media only screen and (max-width: 900px) {
    height: 45px;
  }
  &.hide {
    opacity: 0;
    display: none;
  }
  & > div {
    & > div {
      & > button {
        &:hover {
          background: #202020 !important;
        }
      }
      & > div {
        & > button {
          &:hover {
            background: #202020 !important;
          }
        }
      }
    }
    & > button {
      &:hover {
        background: #202020 !important;
      }
    }
  }
  & > button {
    &:hover {
      background: #202020 !important;
    }
  }
`;

const ProgressBar = styled.div`
  width: calc(100% - 49px);

  position: relative;
  display: flex;

  height: 30px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
const Buttons = styled.div`
  height: 60px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 30px);
`;
const PauseVolumeSection = styled.div`
  width: 80px;
  /* margin-left: 30px; */
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`;
const Icons = styled.img`
  padding: 0;
  height: 20px;
  width: 20px;
`;
const FullSettingSection = styled.div`
  width: 80px;
  /* margin-right: 30px; */
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: start;
  img {
    cursor: pointer;
    height: 20px;
    width: 20px;
  }
`;
const TimeVolume = styled.div`
  position: absolute;
  left: 0;
  margin-right: 2px;
  display: flex;
  width: auto;
  height: 30px;
  align-items: center;
  justify-content: center;
  transition: all 600ms;
  margin-left: 100px;
`;

const VolumeCont = styled.div`
  position: relative;
  display: flex;
  width: 0px;
  height: 30px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  transition: all 600ms;
  z-index: -1;

  &.show {
    width: 100px;
    opacity: 1;
    z-index: 1;
  }
`;
const Sppiner = styled.div`
  position: absolute;
  top: 47%;
  left: 47%;
  z-index: 22;
  translate: transform(-50%, -50%) !important;
  opacity: 1;
  &.hide {
    opacity: 0;
  }
`;

const TimeSection = styled.div`
  margin-left: 5px;

  color: #ffffff;
  font-size: 12px;
  font-family: "Poppins Medium";
  font-weight: 600;
  display: flex;
  flex-direction: row;
  & > div {
    font-size: 12px;
    color: #ffffff;
    font-family: "Poppins Medium";
    font-weight: 600;
  }
`;

export default class VideoTest extends Component {
  constructor(props) {
    super(props);
    this.cardRef = React.createRef();
    this._videoEl = null;
    this._onNativeVolumeChange = null;
    // Ensure we always have a unique DOM id for this instance.
    // (Some call sites don't pass `id`, and global DOM queries must not target the wrong <video>.)
    this._domId = this.props.id || `video-player-${++__videoPlayerSeq}`;
    this._getId = (suffix) => `${this._domId}-${suffix}`;
    // Remember last non-zero volume when muting
    this._lastVolume = this.props.isMute ? 0.5 : 0.5;
    this.state = {
      showdropdown: false,
      showQuality: false,
      showSpeed: false,

      play: this.props.autoPlay,
      ismute: this.props.isMute,
      volume: this.props.isMute === true ? 0 : 0.5,
      currentTime: 0,
      videoTime: 0,
      media: {},
      loading: true, // Add loading state for spinner control
      isSeeking: false,

      srcs: this.props.src,

      //////////////setting options
      settingOp: [
        {
          type: 2,
          title: "Speed",
          icon: null,
          func: () => {
            this.setState({ showQuality: true });
          },
          selected: false,
          disable: this.props.isLive === true ? true : false,
        },
        {
          type: 2,
          title: "Quality",
          selected: false,

          icon: null,
          func: () => {
            this.setState({ showQuality: true });
          },
          disable: this.props.isLive === true ? false : true,
        },
      ],
    };
  }

  _nativeHlsSupport = (videoEl) => {
    if (!videoEl || typeof videoEl.canPlayType !== "function") return "";
    try {
      return (
        videoEl.canPlayType("application/vnd.apple.mpegurl") ||
        videoEl.canPlayType("application/x-mpegURL") ||
        ""
      );
    } catch (_) {
      return "";
    }
  };

  _isProbablyIOS = () => {
    try {
      const ua = navigator?.userAgent || "";
      const iOSUA = /iP(hone|od|ad)/i.test(ua);
      // iPadOS 13+ reports as Mac but has touch points
      const iPadOS = navigator?.platform === "MacIntel" && (navigator?.maxTouchPoints || 0) > 1;
      return iOSUA || iPadOS;
    } catch (_) {
      return false;
    }
  };

  _isProbablySafari = () => {
    try {
      const ua = navigator?.userAgent || "";
      // Exclude Chrome/Chromium/Android; keep Safari + iOS WebViews.
      return /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Android/i.test(ua);
    } catch (_) {
      return false;
    }
  };

  componentDidUpdate(prevProps) {
    // ✅ Seamless source switching (Multi-POV): update the underlying player without remounting.
    if (prevProps.src !== this.props.src) {
      const nextSrc = this.props.src;
      if (!nextSrc) return;

      console.log("🔁 VideoPlayer: src changed", { from: prevProps.src, to: nextSrc });

      // Reset error/loading for the new source
      if (this._isMounted) {
        this.setState({ loading: true, error: null });
      }

      const videoEl = document.getElementById(this._domId);
      // Keep native element in sync with UI state (mute/volume) before re-attaching engines.
      if (videoEl) {
        try {
          videoEl.muted = !!this.state.ismute;
          videoEl.defaultMuted = !!this.state.ismute;
          if (typeof videoEl.volume === "number") {
            videoEl.volume = this.state.volume ?? 0.5;
          }
        } catch (_) { }
      }

      // HLS.js path (used for .m3u8)
      if (this.hlsInstance) {
        try {
          // POV switching bugfix: fully reset HLS between sources.
          // Re-using an existing Hls instance sometimes leaves the player stuck buffering
          // until a full page refresh. Destroy + recreate is the most reliable.
          try { this.hlsInstance.stopLoad(); } catch (_) { }
          try { this.hlsInstance.detachMedia(); } catch (_) { }
          try { this.hlsInstance.destroy(); } catch (_) { }
          this.hlsInstance = null;

          if (!videoEl) return;

          // Clear any native state that could block the new media pipeline.
          try {
            videoEl.pause?.();
            videoEl.removeAttribute("src");
            videoEl.load?.();
          } catch (_) { }

          const nativeHls = this._nativeHlsSupport(videoEl);
          const preferNativeHls = !!nativeHls && (this._isProbablyIOS() || this._isProbablySafari());

          if (preferNativeHls) {
            // Native HLS is typically the most reliable on Safari/iOS.
            try {
              videoEl.src = nextSrc;
              videoEl.load();
              const onReady = () => {
                if (!this._isMounted) return;
                this.setState({ loading: false });
                if (this.props.autoPlay) {
                  videoEl.play().catch(() => { });
                }
              };
              videoEl.addEventListener("loadedmetadata", onReady, { once: true });
              videoEl.addEventListener("canplay", onReady, { once: true });
              return;
            } catch (_) { }
          }

          if (Hls.isSupported()) {
            const hls = new Hls({
              debug: false,
              enableWorker: true,
              lowLatencyMode: true,
              backBufferLength: 90,
              maxBufferLength: 30,
              maxMaxBufferLength: 60,
              maxBufferSize: 60 * 1000 * 1000,
              maxBufferHole: 0.5,
              highBufferWatchdogPeriod: 2,
              nudgeOffset: 0.2,
              nudgeMaxRetry: 5,
              maxFragLookUpTolerance: 0.25,
              liveSyncDurationCount: 3,
              liveMaxLatencyDurationCount: 10
            });

            hls.loadSource(nextSrc);
            hls.attachMedia(videoEl);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
              if (!this._isMounted) return;
              this.setState({ loading: false });
              if (this.props.autoPlay) {
                videoEl.play().catch(() => { });
              }
            });

            hls.on(Hls.Events.ERROR, (_event, data) => {
              // Keep behavior consistent with mount path: don't block page UI,
              // but stop the spinner on fatal errors.
              if (!this._isMounted) return;
              if (data?.fatal) {
                this.setState({ loading: false });
                try {
                  switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                      hls.startLoad();
                      break;
                    case Hls.ErrorTypes.MEDIA_ERROR:
                      hls.recoverMediaError();
                      break;
                    default:
                      break;
                  }
                } catch (_) { }
              }
            });

            this.hlsInstance = hls;
            return;
          }

          // Native HLS fallback (Safari/iOS)
          try {
            videoEl.src = nextSrc;
            videoEl.load();
            const onReady = () => {
              if (!this._isMounted) return;
              this.setState({ loading: false });
              if (this.props.autoPlay) {
                videoEl.play().catch(() => { });
              }
            };
            videoEl.addEventListener("loadedmetadata", onReady, { once: true });
            videoEl.addEventListener("canplay", onReady, { once: true });
            return;
          } catch (_) { }
        } catch (e) {
          console.error("❌ VideoPlayer: failed to switch HLS source:", e);
          if (this._isMounted) this.setState({ error: "Erreur de lecture vidéo" });
        }
      }

      // video.js path
      if (this.player && typeof this.player.src === "function") {
        try {
          this.player.src(nextSrc);
          if (this.props.autoPlay && typeof this.player.play === "function") {
            this.player.play().catch?.(() => { });
          }
          if (this._isMounted) this.setState({ loading: false });
          return;
        } catch (e) {
          console.error("❌ VideoPlayer: failed to switch video.js source:", e);
        }
      }

      // Native video fallback
      if (videoEl) {
        try {
          videoEl.src = nextSrc;
          videoEl.load();
          if (this.props.autoPlay) {
            videoEl.play().catch(() => { });
          }
          if (this._isMounted) this.setState({ loading: false });
        } catch (e) {
          console.error("❌ VideoPlayer: failed to switch native video source:", e);
        }
      }
    }
  }

  _getCurrentTime = () => {
    const videojs = window.videojs;

    var player = videojs(this._domId);
    var totalSeconds = player.currentTime();
    const pb = document.getElementById(this._getId("progressbar"));
    if (pb) pb.value = totalSeconds;

    var hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    const sEl = document.getElementById(this._getId("seconds"));
    const mEl = document.getElementById(this._getId("minutes"));
    const hEl = document.getElementById(this._getId("hours"));
    if (sEl) sEl.innerHTML = seconds < 10 ? "0" + seconds.toFixed(0) : seconds.toFixed(0);
    if (mEl) mEl.innerHTML = minutes < 10 ? "0" + minutes.toFixed(0) : minutes.toFixed(0);
    if (hEl && hours !== 0) hEl.innerHTML = hours < 10 ? "0" + hours.toFixed(0) : hours.toFixed(0) + ":";
  };

  _getVideotime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    const format = (val) => (val < 10 ? "0" + val : val);

    // Update final duration UI elements if they exist
    const hF = document.getElementById(this._getId("hoursF"));
    const mF = document.getElementById(this._getId("minutesF"));
    const sF = document.getElementById(this._getId("secondsF"));

    if (hF) hF.innerHTML = hours > 0 ? format(hours) : "";
    if (mF) mF.innerHTML = format(minutes);
    if (sF) sF.innerHTML = format(seconds);

    return `${hours > 0 ? hours + ':' : ''}${format(minutes)}:${format(seconds)}`;
  };

  componentDidMount() {
    this._isMounted = true;
    const isFlv = this.props.src && this.props.src.endsWith('.flv');
    const isHls = !isFlv && this.props.src && (this.props.src.endsWith('.m3u8') || this.props.src.includes('hls') || this.props.type === 'hls');
    console.log("🎥 VideoPlayer: src =", this.props.src);
    console.log("🎥 VideoPlayer: isFlv =", isFlv);
    console.log("🎥 VideoPlayer: isHls =", isHls);
    console.log("🎥 VideoPlayer: type =", this.props.type);
    console.log("🎥 VideoPlayer: props =", this.props);

    // ✅ Validation de l'URL HLS
    if (this.props.src) {
      try {
        const url = new URL(this.props.src);
        console.log("🎥 VideoPlayer: URL validée:", url.href);
        console.log("🎥 VideoPlayer: Protocol:", url.protocol);
        console.log("🎥 VideoPlayer: Hostname:", url.hostname);
        console.log("🎥 VideoPlayer: Pathname:", url.pathname);

        // ✅ Vérification spécifique pour AWS IVS
        if (url.hostname.includes('playback.live-video.net')) {
          console.log("✅ URL AWS IVS détectée");
        }
      } catch (error) {
        console.error("❌ VideoPlayer: URL invalide:", this.props.src, error);
        this.setState({ error: "URL de stream invalide" });
        return;
      }
    }

    const primeNativeAudioState = (videoEl) => {
      if (!videoEl) return;
      // Store reference for later sync
      this._videoEl = videoEl;

      // iOS/Safari: keep playback inline when possible
      try {
        videoEl.playsInline = true;
        videoEl.setAttribute("playsinline", "");
        videoEl.setAttribute("webkit-playsinline", "");
      } catch (_) { }

      // Ensure actual media element matches initial UI state
      try {
        const nextMuted = !!this.state.ismute;
        videoEl.muted = nextMuted;
        videoEl.defaultMuted = nextMuted;
        // Volume is ignored when muted, but set it for when user unmutes.
        if (typeof videoEl.volume === "number") {
          videoEl.volume = this.state.volume ?? 0.5;
        }
      } catch (_) { }

      // Keep UI in sync with the real element (autoplay policies can change muted)
      this._onNativeVolumeChange = () => {
        if (!this._isMounted) return;
        try {
          const actualMuted = !!videoEl.muted;
          const actualVolume = typeof videoEl.volume === "number" ? videoEl.volume : this.state.volume;
          // Avoid noisy loops
          if (actualMuted !== this.state.ismute || actualVolume !== this.state.volume) {
            if (actualVolume > 0) this._lastVolume = actualVolume;
            this.setState({ ismute: actualMuted, volume: actualMuted ? 0 : actualVolume });
          }
        } catch (_) { }
      };
      try {
        videoEl.addEventListener("volumechange", this._onNativeVolumeChange);
      } catch (_) { }
    };

    if (isFlv && window.flvjs && window.flvjs.isSupported()) {
      console.log('🎥 VideoPlayer: Using flv.js for FLV playback');
      const flvjs = window.flvjs;
      const video = document.getElementById(this._domId);
      if (!video) {
        console.error('❌ VideoPlayer: FLV video element not found');
        return;
      }
      primeNativeAudioState(video);
      const flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: this.props.src,
        isLive: false
      }, {
        enableStashBuffer: false,
        stashInitialSize: 128
      });

      flvPlayer.attachMediaElement(video);
      flvPlayer.load();
      // Autoplay if requested
      if (this.props.autoPlay) {
        flvPlayer.play();
      }
      // Save reference for clean-up
      this.flvPlayer = flvPlayer;

      const updateDur = () => {
        if (video.duration && isFinite(video.duration)) {
          this._getVideotime(video.duration);
          this.setState({ videoTime: video.duration });
        }
      };
      video.addEventListener('loadedmetadata', updateDur);
      video.addEventListener('durationchange', updateDur);

      flvPlayer.on(flvjs.Events.METADATA_ARRIVED, (mediaInfo) => {
        const dur = mediaInfo?.duration || video.duration;
        if (dur && isFinite(dur)) {
          this._getVideotime(dur);
          this.setState({ videoTime: dur });
        }
      });

    } else if (isHls) {
      // HLS playback:
      // - Prefer Hls.js when supported (MSE)
      // - Otherwise fall back to native HLS (Safari/iOS), which avoids A/V desync issues
      //   and ensures the browser controls audio correctly.
      const video = document.getElementById(this._domId);
      if (!video) {
        console.error("❌ VideoPlayer: Video element not found with id:", this.props.id);
        return;
      }
      primeNativeAudioState(video);

      const nativeHls = this._nativeHlsSupport(video);
      const preferNativeHls = !!nativeHls && (this._isProbablyIOS() || this._isProbablySafari());

      if (preferNativeHls) {
        // Native HLS (Safari/iOS): avoids common MSE/Hls.js quirks on iPhone.
        console.log("🎥 VideoPlayer: Using native HLS playback (Safari/iOS preference)");
        try {
          video.src = this.props.src;
          video.load();
          const onReady = () => {
            if (!this._isMounted) return;
            this.setState({ loading: false });
            if (this.props.autoPlay) {
              video.play().catch(() => { });
            }
          };
          video.addEventListener("loadedmetadata", onReady, { once: true });
          video.addEventListener("canplay", onReady, { once: true });
        } catch (e) {
          console.error("❌ VideoPlayer: native HLS init failed:", e);
          if (this._isMounted) this.setState({ loading: false, error: "Erreur de lecture vidéo" });
        }
        return;
      }

      if (Hls.isSupported()) {
        console.log("🎥 VideoPlayer: Using HLS.js for playback");

        console.log("🎥 VideoPlayer: Video element found, initializing HLS...");

        const hls = new Hls({
          debug: false, // ✅ Désactiver le debug en production
          enableWorker: true,
          lowLatencyMode: true,
          backBufferLength: 90,
          maxBufferLength: 30,
          maxMaxBufferLength: 60,
          maxBufferSize: 60 * 1000 * 1000, // 60MB
          maxBufferHole: 0.5,
          highBufferWatchdogPeriod: 2,
          nudgeOffset: 0.2,
          nudgeMaxRetry: 5,
          maxFragLookUpTolerance: 0.25,
          liveSyncDurationCount: 3,
          liveMaxLatencyDurationCount: 10
        });

        console.log("🎥 VideoPlayer: Loading HLS source:", this.props.src);
        hls.loadSource(this.props.src);
        hls.attachMedia(video);

        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          console.log("✅ HLS manifest parsed successfully, trying to play...");
          // Hide spinner when manifest is parsed successfully
          if (this._isMounted) {
            this.setState({ loading: false });
          }
          if (this.props.autoPlay) {
            video.play().catch(() => {
              // Autoplay can be blocked; don't spam retries.
            });
          }
        });

        // ✅ Add loadedmetadata event to adjust container aspect ratio dynamically
        video.addEventListener('loadedmetadata', () => {
          console.log("✅ Video metadata loaded");
          console.log("📐 Video dimensions:", video.videoWidth, "x", video.videoHeight);

          // Update container aspect ratio to match video
          const card = this.cardRef?.current;
          const testCont = card?.parentElement;
          const cont = testCont?.parentElement; // The Cont styled component

          if (cont && video.videoWidth && video.videoHeight) {
            const aspectRatio = video.videoWidth / video.videoHeight;
            cont.style.aspectRatio = `${aspectRatio}`;

            console.log("📐 Container aspect ratio set to:", aspectRatio);
          }
        });

        // Create a bound error handler to preserve React component context
        const handleHlsError = (event, data) => {
          console.error("❌ HLS.js error:", data);
          console.error("❌ Error URL:", data.url);
          console.error("❌ Error type:", data.type);
          console.error("❌ Error details:", data.details);
          console.error("❌ Error fatal:", data.fatal);

          // Prevent setState calls on unmounted components
          if (!this._isMounted) {
            console.log("⚠️ Component unmounted, skipping setState");
            return;
          }

          if (data.fatal) {
            // Hide spinner on fatal errors
            if (this._isMounted) {
              this.setState({ loading: false });
            }
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.log("🔄 Erreur réseau fatale, tentative de récupération...");
                if (data.details === 'manifestLoadError') {
                  console.error("❌ Impossible de charger le manifest HLS. Vérifiez l'URL:", data.url);
                  // Ne pas afficher d'overlay d'erreur ici; laisser la page décider
                } else {
                  hls.startLoad();
                }
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log("🔄 Erreur média fatale, tentative de récupération...");
                hls.recoverMediaError();
                break;
              default:
                console.error("❌ Erreur fatale non récupérable:", data);
                // Ne pas afficher d'overlay d'erreur; logs uniquement
                break;
            }
          } else {
            console.log("⚠️ Erreur non fatale HLS:", data.details);
            if (data.details === 'bufferStalledError') {
              console.log("🔄 Buffer stalling détecté");
              // Ne pas afficher de message d'arrêt de stream côté UI
            }
          }
        };

        hls.on(Hls.Events.ERROR, handleHlsError);

        // ✅ Ajouter des événements pour le monitoring
        hls.on(Hls.Events.FRAG_LOADED, () => {
          console.log("✅ Fragment HLS chargé avec succès");
        });

        hls.on(Hls.Events.LEVEL_LOADED, () => {
          console.log("✅ Niveau de qualité HLS chargé");
        });

        hls.on(Hls.Events.MANIFEST_LOADING, () => {
          console.log("🔄 Chargement du manifest HLS...");
        });

        hls.on(Hls.Events.MANIFEST_LOADED, () => {
          console.log("✅ Manifest HLS chargé avec succès");
        });

        video.addEventListener('error', (e) => {
          console.error("❌ Erreur vidéo native:", e, video.error);
          this.setState({ error: "Erreur de lecture vidéo native" });
        });

        this.hlsInstance = hls;
      } else {
        // Native HLS fallback (Safari/iOS)
        console.log("🎥 VideoPlayer: Using native HLS playback (no Hls.js support)");
        try {
          video.src = this.props.src;
          video.load();
          const onReady = () => {
            if (!this._isMounted) return;
            this.setState({ loading: false });
            if (this.props.autoPlay) {
              video.play().catch(() => { });
            }
          };
          video.addEventListener("loadedmetadata", onReady, { once: true });
          video.addEventListener("canplay", onReady, { once: true });
        } catch (e) {
          console.error("❌ VideoPlayer: native HLS init failed:", e);
          if (this._isMounted) this.setState({ loading: false, error: "Erreur de lecture vidéo" });
        }
      }
    } else {
      console.log("🎥 VideoPlayer: Using video.js for playback");
      this.initVideo();
    }

    const videoElement = document.getElementById(this._domId);
    if (videoElement) {
      videoElement.addEventListener('error', (e) => {
        console.error("Erreur vidéo:", e, videoElement.error);
      });
      const updateProgressNative = () => {
        if (this.state.isSeeking) return;
        const progressBar = document.getElementById(this._getId("progressbar"));
        if (progressBar) {
          progressBar.value = videoElement.currentTime;
        }
        this._getCurrentTime();
      };
      videoElement.addEventListener('timeupdate', updateProgressNative);

      // ✅ Add loadedmetadata for native video (non-HLS) playback
      const adjustContainerHeight = () => {
        console.log("✅ Video metadata loaded (native)");
        console.log("📐 Video dimensions:", videoElement.videoWidth, "x", videoElement.videoHeight);

        const card = this.cardRef?.current;
        const testCont = card?.parentElement;
        const cont = testCont?.parentElement; // The Cont styled component

        if (cont && videoElement.videoWidth && videoElement.videoHeight) {
          const aspectRatio = videoElement.videoWidth / videoElement.videoHeight;
          cont.style.aspectRatio = `${aspectRatio}`;

          console.log("📐 Container aspect ratio set to:", aspectRatio);
        }
      };

      videoElement.addEventListener('loadedmetadata', adjustContainerHeight);
    }
  }


  componentWillUnmount() {
    // Mark component as unmounted to prevent setState calls
    this._isMounted = false;

    // Clear any pending timeouts
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
      this.errorTimeout = null;
    }

    // Remove native volume listener (HLS/native video)
    if (this._videoEl && this._onNativeVolumeChange) {
      try {
        this._videoEl.removeEventListener("volumechange", this._onNativeVolumeChange);
      } catch (_) { }
    }
    this._videoEl = null;
    this._onNativeVolumeChange = null;

    // Clean up HLS instance
    if (this.hlsInstance) {
      console.log("🧹 Cleaning up HLS instance...");
      try {
        this.hlsInstance.destroy();
      } catch (error) {
        console.error("❌ Error destroying HLS instance:", error);
      }
      this.hlsInstance = null;
    }

    // Clean up FLV player
    if (this.flvPlayer) {
      console.log("🧹 Cleaning up FLV player...");
      try {
        this.flvPlayer.destroy();
      } catch (error) {
        console.error("❌ Error destroying FLV player:", error);
      }
      this.flvPlayer = null;
    }

    // Clean up Video.js player
    if (this.player) {
      console.log("🧹 Cleaning up Video.js player...");
      try {
        this.player.dispose();
      } catch (error) {
        console.error("❌ Error disposing Video.js player:", error);
      }
      this.player = null;
    }
  }

  // componentWillUnmount() {
  //   if (this.player) {
  //     this.player.dispose();
  //   }
  // }

  setspeed(speed) {
    this.player.playbackRate(speed);
  }
  mouse(element, delay, callback) {
    // Counter Object
    element.ms = {};

    // Counter Value
    element.ms.x = 0;

    // Counter Function
    element.ms.y = function () {
      // Callback Trigger
      if (++element.ms.x === delay) element.ms.callback(element, element.ms);
    };

    // Counter Callback
    element.ms.callback = callback;

    // Function Toggle
    element.ms.toggle = function (state) {
      // Stop Loop
      if ([0, "off"][state]) clearInterval(element.ms.z);

      // Create Loop
      if ([1, "on"][state]) element.ms.z = setInterval(element.ms.y, 1);
    };

    // Function Disable
    element.ms.remove = function () {
      // Delete Counter Object
      element.ms = null;
      return delete element.ms;
    };

    // Function Trigger
    element.onmousemove = function () {
      // Reset Counter Value
      element.ms.x = -1;
    };

    // Return
    return element.ms;
  }

  initVideo() {
    // Here, we load videojs, IVS tech, and the IVS quality plugin
    // These must be prefixed with window. because they are loaded to the window context
    // in web-ui/public.
    const videojs = window.videojs;
    if (this.props.isLive === true) {
      const registerIVSTech = window.registerIVSTech,
        registerIVSQualityPlugin = window.registerIVSQualityPlugin;
      registerIVSTech(videojs);
      registerIVSQualityPlugin(videojs);
    }
    // registerIVSTech = window.registerIVSTech,
    // registerIVSQualityPlugin = window.registerIVSQualityPlugin;

    // Set up IVS playback tech and quality plugin

    const videoJsOptions = {
      techOrder: ["AmazonIVS"],
      muted: this.state.ismute,
      liveui: true,
      nativeControlsForTouch: false,
      responsive: false,
      fullscreen: {
        alwaysInLandscapeMode: true,
      },
      loadingSpinner: false,
      userActions: {
        hotkeys: (event) => {
          // `this` is the player in this context
          if (event.code === "KeyF") {
            this.fullscreen();
          }

          if (event.code === "Space") {
            this.play();
            // event.preventDefault()
          }
          if (event.code === "KeyM") {
            this.mute();
          }
        },
      },

    };
    this.props.isLive === false && delete videoJsOptions.techOrder;

    // instantiate video.js
    this.player = videojs(this._domId, videoJsOptions);
    // var options = {
    //   id: 'content_video',
    //   adTagUrl: 'http://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&impl=s&gdfp_req=1&env=vp&output=xml_vmap1&unviewed_position_start=1&cust_params=sample_ar%3Dpremidpostpod%26deployment%3Dgmf-js&cmsid=496&vid=short_onecue&correlator='
    // };
    // this.player.ima(options);    
    // Important: pass callback, don't invoke immediately
    this.player.ready(this.handlePlayerReady);

    this.player.on('error', () => {
      console.error('Erreur video.js:', this.player.error());

      // ✅ Gestion améliorée des erreurs video.js
      const error = this.player.error();
      if (error) {
        console.error('Code erreur video.js:', error.code);
        console.error('Message erreur video.js:', error.message);

        // Tentative de récupération pour certaines erreurs
        if (error.code === 4) { // MEDIA_ERR_SRC_NOT_SUPPORTED
          console.log("Format non supporté, tentative de fallback...");
          // Ici vous pourriez essayer un format alternatif
        }
      }
    });
  }

  setQyalityForStream() {
    this.player.enableIVSQualityPlugin();

    var t = this.player.getIVSPlayer();
    // console.log(t.core.state)

    var dropqualities = [
      {
        type: 2,
        title: "Back",
        icon: previous,
        func: () => {
          this.setState({ showQuality: false, showdropdown: true });
        },
        disable: false,
        selcted: false,
      },
      {
        type: 2,
        title: "Auto",
        icon: null,
        selected: true,
        func: () => {
          t.core.setAutoQualityMode(true);
          var newlist = this.state.qualityOp;
          for (let index = 0; index < newlist.length; index++) {
            if (index === 1) newlist[index].selected = true;
            else newlist[index].selected = false;
          }
          this.setState({ qualityOp: newlist, showdropdown: false, showQuality: false });
        },
        disable: false,
      },
    ];
    this.player.on("loadedmetadata", () => {
      t.core.state.autoQualityMode = true;
      var qualities = t.core.state.qualities;
      var list = [];

      qualities.forEach((element) => list.push(element.name));
      if (dropqualities.length === 2) {
        for (let index = 0; index < list.length; index++) {
          var x = {
            type: 2,
            selected: false,
            title: list[index],
            icon: null,
            func: () => {
              t.core.setQuality(qualities[index]);
              var newlists = this.state.qualityOp;
              for (let i = 0; i < newlists.length; i++) {
                if (i === index + 2) newlists[i].selected = true;
                else newlists[i].selected = false;
              }
              this.setState({ qualityOp: newlists, showdropdown: false, showQuality: false });
            },
          };
          dropqualities.push(x);
        }
      }

      ////////////////////////////////////////
    });
    this.setState({ qualityOp: dropqualities });
  }

  handlePlayerReady = () => {
    this.player.src(this.props.src);
    this.player.fluid(this.props.isLive);
    if (this.props.isLive === true) {
      this.setQyalityForStream();
    } else {
      var dropqualities = [
        {
          type: 2,
          title: "Back",
          icon: previous,
          func: () => {
            this.setState({ showQuality: false, showdropdown: true });
          },
          disable: false,
          selcted: false,
        },
        {
          type: 2,
          title: "0.5",
          icon: null,
          func: () => {
            this.setState({ showQuality: false, showdropdown: false });
            this.setspeed(0.5);
          },
          disable: false,
          selcted: false,
        },
        {
          type: 2,
          title: "1",
          icon: null,
          func: () => {
            this.setState({ showQuality: false, showdropdown: false });
            this.setspeed(1);
          },
          disable: false,
          selcted: false,
        },
        {
          type: 2,
          title: "1.5",
          icon: null,
          func: () => {
            this.setState({ showQuality: false, showdropdown: false });
            this.setspeed(1.5);
          },
          disable: false,
          selcted: false,
        },
        {
          type: 2,
          title: "2",
          icon: null,
          func: () => {
            this.setState({ showQuality: false, showdropdown: false });
            this.setspeed(2);
          },
          disable: false,
          selcted: false,
        },
      ];

      this.setState({ qualityOp: dropqualities });
      this.player.on("loadeddata", () => {
        const dur = this.player.duration();
        if (dur && isFinite(dur)) {
          this._getVideotime(dur);
          this.setState({ videoTime: dur });
        }
        // Hide spinner when video data is loaded
        const spinner = document.getElementById(this._getId("spinner"));
        if (spinner) {
          spinner.style.display = "none";
        }
      });
      this.player.on("durationchange", () => {
        const dur = this.player.duration();
        if (dur && isFinite(dur)) {
          this._getVideotime(dur);
          this.setState({ videoTime: dur });
        }
      });

      // Also hide spinner when video starts playing
      this.player.on("playing", () => {
        const spinner = document.getElementById(this._getId("spinner"));
        if (spinner) {
          spinner.style.display = "none";
        }
      });

      // Show spinner when video is buffering/waiting
      this.player.on("waiting", () => {
        const spinner = document.getElementById(this._getId("spinner"));
        if (spinner) {
          spinner.style.display = "block";
        }
      });
    }

    // Ensure the underlying media element matches initial mute/volume state
    try {
      const videoEl = document.getElementById(this._domId);
      if (videoEl) {
        videoEl.muted = !!this.state.ismute;
        videoEl.defaultMuted = !!this.state.ismute;
        videoEl.volume = this.state.volume ?? 0.5;
      }
      if (this.player && typeof this.player.muted === "function") {
        this.player.muted(!!this.state.ismute);
      }
      if (this.player && typeof this.player.volume === "function") {
        this.player.volume(this.state.volume ?? 0.5);
      }
    } catch (_) { }
    const waitingEl = document.getElementById(this._domId);
    if (waitingEl) waitingEl.classList.add("vjs-waiting");

    // Show spinner when loading starts
    const spinner = document.getElementById(this._getId("spinner"));
    if (spinner) {
      spinner.style.display = "block";
    }

    var timers;
    this.player.on("touchstart", (e) => {
      this.play();
      clearTimeout(timers);
      const cb = document.getElementById(this._getId("control-bar"));
      if (cb) cb.classList.remove("hide");
      timers = setTimeout(() => {
        const cb2 = document.getElementById(this._getId("control-bar"));
        if (cb2) cb2.classList.add("hide");
        this.setState({ showdropdown: false });
      }, 6000);
    });
    this.player.on("click", (evt) => {
      this.play(this);
      const cb = document.getElementById(this._getId("control-bar"));
      if (cb) cb.classList.remove("hide");
    });
    this.player.on("fullscreenchange", function (e) {
      this.controls(false);
    });

    if (this.props.autoPlay === true) this.player.play();

    const updateProgress = () => {
      if (this.state.isSeeking) return;
      const progressBar = document.getElementById(this._getId("progressbar"));
      if (progressBar) {
        progressBar.value = this.player.currentTime();
      }
      this._getCurrentTime();
    };
    this.player.on("timeupdate", updateProgress);
  };

  play() {
    // Essaye d'abord la balise DOM (HLS.js)
    var video = document.getElementById(this._domId) || this._videoEl || document.getElementById(this.props.id);
    if (video && typeof video.paused !== "undefined") {
      if (video.paused) {
        video.play().catch((error) => { });
      } else {
        video.pause();
      }
      this.setState({ play: !this.state.play });
      this._togglePlay();
      return;
    }
    // Sinon, fallback sur video.js (pour les autres cas)
    if (this.player && typeof this.player.paused === "function") {
      if (this.player.paused()) {
        this.player.play().catch((error) => { });
      } else {
        this.player.pause();
      }
      this.setState({ play: !this.state.play });
      this._togglePlay();
    }
  }
  mute() {
    const video = document.getElementById(this._domId) || this._videoEl;
    // Use state as source of truth (autoplay policies can force muted=true)
    this.setState((prev) => {
      // Store last non-zero volume before muting
      if (!prev.ismute && prev.volume > 0) this._lastVolume = prev.volume;

      const nextIsMute = !prev.ismute;
      const nextVolume = nextIsMute ? 0 : (this._lastVolume && this._lastVolume > 0 ? this._lastVolume : 0.5);
      return { ismute: nextIsMute, volume: nextVolume };
    }, () => {
      try {
        if (video) {
          video.muted = !!this.state.ismute;
          if (!this.state.ismute) {
            // Restore volume when unmuting
            video.volume = this.state.volume || 0.5;
          }
        }
        // If we're running through video.js, keep it in sync too.
        if (this.player && typeof this.player.muted === "function") {
          this.player.muted(!!this.state.ismute);
        }
        if (this.player && typeof this.player.volume === "function") {
          this.player.volume(this.state.volume ?? 0.5);
        }
      } catch (_) { }
    });
  }

  fullscreen() {
    var card = this.cardRef?.current || document.getElementById("card");

    if (!document.fullscreenElement) {
      card.requestFullscreen();
    } else document.exitFullscreen();
  }

  _togglePlay() {
    var button = document.getElementById("bigplay");
    button.classList.add("test");

    const timer = setTimeout(() => {
      button.classList.remove("test");
    }, 500);
    return () => clearTimeout(timer);
  }
  changeVolume(event) {
    const video = document.getElementById(this._domId) || this._videoEl;
    const vRaw = event.target.valueAsNumber;
    const v = Number.isFinite(vRaw) ? Math.min(1, Math.max(0, vRaw)) : 0;
    try {
      if (video) {
        video.volume = v;
        const nextMuted = v === 0;
        video.muted = nextMuted;
        // Some browsers keep defaultMuted sticky after autoplay;
        // clear it on any user-initiated volume change.
        try { video.defaultMuted = nextMuted; } catch (_) { }

        // If user is trying to unmute via the slider, ensure playback resumes with audio.
        if (!nextMuted) {
          try { video.muted = false; } catch (_) { }
          try { video.defaultMuted = false; } catch (_) { }
          try {
            // Calling play() inside a user gesture helps Safari/Chrome apply unmute.
            if (typeof video.play === "function") video.play().catch(() => { });
          } catch (_) { }
        }
      }
      // If we're running through video.js, keep it in sync too.
      if (this.player && typeof this.player.volume === "function") {
        this.player.volume(v);
      }
      if (this.player && typeof this.player.muted === "function") {
        this.player.muted(v === 0);
      }
    } catch (_) { }
    if (v > 0) this._lastVolume = v;
    this.setState({ volume: v, ismute: v === 0 });
  }
  showVolumecont() {
    var volumeCont = document.getElementById(this._getId("volume-cont"));
    if (volumeCont) volumeCont.classList.add("show");
  }
  hideVolumecont() {
    var volumeCont = document.getElementById(this._getId("volume-cont"));
    if (volumeCont) volumeCont.classList.remove("show");
  }

  render() {
    return (
      <div className="test-cont">
        <div className="card" id={this._getId("card")} ref={this.cardRef}>
          <Sppiner id={this._getId("spinner")} className={`sp sp-circle ${!this.state.loading ? 'hide' : ''}`}></Sppiner>

          {/* Affichage des erreurs de stream */}
          {/* No in-player error overlay; parent page handles offline UI */}

          <video
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
            }}
            onClick={this.play.bind(this)}
            id={this._domId}
            className="video-js"
            // controls={true}
            preload="auto"
            data-setup='{"liveui": true}'
            autoPlay={this.props.autoPlay}
            muted={!!this.state.ismute}
            playsInline
            poster={this.props.poster}
          ></video>

          {this.props.isLive && <LiveIcon>LIVE</LiveIcon>}
          <BigPlayPause onClick={this.play.bind(this)} id={this._getId("bigplay")}>
            {this.state.play === true ? (
              <BigPauseIcon style={{ width: "100%", height: "100%" }} />
            ) : (
              <BigPlayIcon style={{ width: "100%", height: "100%" }} />
            )}
          </BigPlayPause>

          <ControlBar id={this._getId("control-bar")}>
            {!this.props.isLive && (
              <ProgressBar>
                <input
                  style={{ width: "100%" }}
                  type="range"
                  className="e-range"
                  id={this._getId("progressbar")}
                  min={0}
                  max={this.state.videoTime}
                  step={1}
                  onMouseDown={() => this.setState({ isSeeking: true })}
                  onMouseUp={() => this.setState({ isSeeking: false })}
                  onTouchStart={() => this.setState({ isSeeking: true })}
                  onTouchEnd={() => this.setState({ isSeeking: false })}
                  onChange={(event) => {
                    const videojs = window.videojs;
                    this.setState({ currentTime: event.target.valueAsNumber });

                    // Keep this consistent with the current instance.
                    var player = videojs(this._domId);
                    player.currentTime(event.target.valueAsNumber);
                  }}
                />
              </ProgressBar>
            )}

            <Buttons>
              <PauseVolumeSection>
                <Button size="small" nofocus icon onClick={this.play.bind(this)}>
                  <Icons
                    alt="playpause"
                    src={this.state.play === true ? pauseButtonIcon : playButtonIcon}
                  />
                </Button>
                <Button
                  nofocus
                  icon
                  onClick={(e) => {
                    // Prevent parent click handlers (e.g. Home slider card) from navigating
                    e.preventDefault();
                    e.stopPropagation();
                    this.mute();
                  }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onTouchStart={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    this.showVolumecont();
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    this.hideVolumecont();
                  }}
                >
                  <Icons
                    alt="Volume"
                    src={
                      this.state.ismute === false
                        ? this.state.volume > 0.9
                          ? volumeMax
                          : volume_mid
                        : muteIcon
                    }
                  />
                </Button>
              </PauseVolumeSection>
              <TimeVolume>
                <VolumeCont
                  id={this._getId("volume-cont")}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    this.hideVolumecont();
                  }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    this.showVolumecont();
                  }}
                >
                  <input
                    style={{ width: "100px" }}
                    className="e-range"
                    type="range"
                    min={0}
                    max={1}
                    step={0.02}
                    value={this.state.volume}
                    // Do NOT preventDefault here: it breaks range dragging.
                    // We only stop propagation to avoid parent click handlers (Home slider cards, etc.).
                    onMouseDown={(e) => { e.stopPropagation(); }}
                    onTouchStart={(e) => { e.stopPropagation(); }}
                    onClick={(e) => { e.stopPropagation(); }}
                    onChange={(event) => {
                      event.stopPropagation();
                      // Route through shared helper to keep UI and element in sync
                      this.changeVolume(event);
                    }}
                  />
                </VolumeCont>

                {!this.props.isLive && (
                  <TimeSection id={this._getId("time")}>
                    <div id={this._getId("hours")}></div>
                    <div id={this._getId("minutes")}></div>: <div id={this._getId("seconds")}></div>/<div id={this._getId("hoursF")}></div>:
                    <div id={this._getId("minutesF")}></div>: <div id={this._getId("secondsF")}></div>
                  </TimeSection>
                )}
              </TimeVolume>

              <FullSettingSection>
                <div style={{ position: "relative" }}>
                  <Button
                    nofocus
                    isPlayer
                    style={{ position: "relative" }}
                    icon
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.setState({ showdropdown: !this.state.showdropdown, showQuality: false });
                    }}
                  >
                    <Icons alt="settings" src={settingsIcon} />
                  </Button>

                  {this.state.showdropdown && (
                    <Dropdown
                      width="140px"
                      isVideoPlayer={true}
                      show={this.state.showdropdown}
                      setShow={(e) => {
                        this.setState({ showdropdown: e });
                      }}
                      style={{ bottom: "100%", transform: "translate(-50%, 0%)" }}
                      options={(this.state.showQuality ? this.state.qualityOp : this.state.settingOp) || []}
                      margin="10px"
                      showQuality={() => {
                        this.setState({ showQuality: true });
                      }}
                      goback={() => {
                        this.setState({ showQuality: false });
                      }}
                    />
                  )}
                </div>

                <Button
                  nofocus
                  icon
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.fullscreen();
                  }}
                >
                  <Icons alt="Fullscreen" src={fullscreenIcon} />
                </Button>
              </FullSettingSection>
            </Buttons>
          </ControlBar>
        </div>
      </div>
    );
  }
}
